module.exports = __webpack_public_path__ + "img/12.b8e5d111.jpg";